import React, { Component } from 'react';
import Recaptcha from 'react-google-invisible-recaptcha';
import Cookies from 'universal-cookie';

let recaptchaInstance;
const cookies = new Cookies();

export default class Contact extends Component {
	constructor(props) {
		super(props);
		this.state = { 
			value: '',
			firstName: localStorage.getItem('firstaname') === null ? '' : localStorage.getItem('firstaname'),
			isFirstNameValid: localStorage.getItem('firstaname') === null ? false : true,
			isFirstNameFocused: false,
			lastName: localStorage.getItem('lastname') === null ? '' : localStorage.getItem('lastname'),
			isLastNameValid: localStorage.getItem('lastname') === null ? false : true,
			isLastNameFocused: false,
			email: localStorage.getItem('email') === null ? '' : localStorage.getItem('email'),
			companyName: '',
			isCompanyNameValid: false,
			isCompanyNameFocused: false,
			isEmailValid: localStorage.getItem('email') === null ? false : true,
            isEmailChecked: '',
			isEmailFocused: false,
			phone: '',
			subject: 'Media Kit Request for More Information',
			isSubmitDisabled: 'disabled',
			//isSubmitDisabled: (localStorage.getItem('firstaname') && localStorage.getItem('lastname') && localStorage.getItem('email')) ? '' : 'disabled',
            displayBtnLoader: false,
            submitResponse: '',
            submitResponseColor: '',
			regexMatcher: new RegExp(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/),
			cookieContent: cookies.get('C_S')
		 };

		this.handleChange = this.handleChange.bind(this);
		this.handleFocus = this.handleFocus.bind(this);
		this.handleClick = this.handleClick.bind(this);
		//this.handleSubmit = this.handleSubmit.bind(this);
		this.verifyCallback = this.verifyCallback.bind(this);
		this.executeCaptcha = this.executeCaptcha.bind(this);
	}

	// manually trigger reCAPTCHA execution
    executeCaptcha() {
        this.setState({
            submitResponseColor: ' yellow',
            submitResponse: 'Submitting, please wait...',
            displayBtnLoader: true
        });
        recaptchaInstance.execute();
	}
	
	// executed once the captcha has been verified
    // can be used to post forms, redirect, etc.
	verifyCallback() {		
		fetch('https://www.couponology.com/api/Email/contactUsSplash?email=' + this.state.email + '&name=' + this.state.firstName +' ' + this.state.lastName + '&companyname=' + this.state.companyName + '&phone=' + this.state.phone + '&subject=' + this.state.subject + '&gRecaptchaResponse=' + recaptchaInstance.getResponse()).then(response => response.json())
            .catch(error => console.error('Error:', error))
            .then(response => this.handleResponse(response));
	}t

	handleChange(event){
		let newState = {};
        newState[event.target.name] = event.target.value;
		this.setState(newState);
		
		if (event.target.name === 'firstName') {
            this.setState({ isFirstNameValid: event.target.value.length > 0 ? true : false });
		}
		
		if (event.target.name === 'lastName') {
            this.setState({ isLastNameValid: event.target.value.length > 0 ? true : false });
		}

		if (event.target.name === 'companyName') {
            this.setState({ isCompanyNameValid: event.target.value.length > 0 ? true : false });
		}
		
		if (event.target.name === 'email') {
            this.setState({ isEmailChecked: event.target.value.match(this.state.regexMatcher) ? 'glyphicon glyphicon-ok green' : 'glyphicon glyphicon-remove red' });
            this.setState({ isEmailValid: event.target.value.match(this.state.regexMatcher) ? true : false });
		}
		
		this.setState({ isSubmitDisabled: (this.state.isFirstNameValid && this.state.isLastNameValid && this.state.isEmailValid && this.state.isCompanyNameValid) ? '' : 'disabled' });
	}

	handleFocus(event) {
		if (event.target.name === 'firstName') {
            this.setState({ isFirstNameFocused: true });
		}
		
		if (event.target.name === 'lastName') {
            this.setState({ isLastNameFocused: true });
		}
		
		if (event.target.name === 'companyName') {
            this.setState({ isCompanyNameFocused: true });
        }

        if (event.target.name === 'email') {
            this.setState({ isEmailFocused: true });
		}
		
		if (event.target.id === 'submit_overlay') {
			this.setState({ isFirstNameFocused: true });
			this.setState({ isLastNameFocused: true });
			this.setState({ isEmailFocused: true });
			this.setState({ isCompanyNameFocused: true });
        }
        this.setState({ submitResponse: '' });
	}

	handleClick(e) {
        this.handleFocus(e);
	}

	/*handleSubmit(event) {
		event.preventDefault();
		
		/* email, firstName, lastName, phone, subject(prefilled in this.state) are in fetch below -- probably just need your API */

        /*fetch('api/Email/contactUsSplash?email=' + this.state.email + '&name=' + this.state.firstName +' ' + this.state.lastName + '&companyname=' + this.state.companyName + '&phone=' + this.state.phone + '&subject=MediaKit Request').then(response => response.json())
            .catch(error => console.error('Error:', error))
            .then(response => this.handleResponse(response));
	}*/

	handleResponse(response) {
		recaptchaInstance.reset();
        if (response === 200) {			
            this.setState({
                submitResponseColor: ' green',
                submitResponse: 'Your contact info has been sent. Thank you!',
                displayBtnLoader: false
            });
        }
        else {
            this.setState({
                submitResponseColor: ' red',
                submitResponse: 'An error has occurred. Please try again.',
                displayBtnLoader: false
            });
        }
    }

	render() {			
		return(
			<div className='contact-form'>
				<div className='inner-content'>
					<h3 className='heading'>Get in Touch With Us</h3>
					<div className='row'>
						<div className='col-md-12 input-container text-center'>
							<input required name='firstName' type='text' placeholder='First Name' onChange={this.handleChange} onKeyUp={this.handleChange} onFocus={this.handleFocus} value={this.state.firstName} />
							<span className={this.state.firstName.length > 0 || !this.state.isFirstNameFocused ? 'visibility-hidden message' : 'required-message message'}>This field is required</span>
						</div>
						<div className='col-md-12 input-container text-center'>
							<input required name='lastName' type='text' placeholder='Last Name' onChange={this.handleChange} onKeyUp={this.handleChange} onFocus={this.handleFocus} value={this.state.lastName} />
							<span className={this.state.lastName.length > 0 || !this.state.isLastNameFocused ? 'visibility-hidden message' : 'required-message message'}>This field is required</span>
						</div>
						<div className='col-md-12 input-container text-center'>
							<input required name='email' type='text' placeholder='Email' onChange={this.handleChange} onKeyUp={this.handleChange} onFocus={this.handleFocus} value={this.state.email} />
							<span className='email-validation-message'><i className={this.state.isEmailChecked}></i></span>
                            <span className={(this.state.email.length > 0 && this.state.isEmailValid) || !this.state.isEmailFocused ? 'visibility-hidden message' : 'required-message message'}>Please enter a valid email</span>
						</div>
						<div className='col-md-12 input-container text-center' style={{paddingBottom: "14px"}}>
							<input name='phone' type='text' placeholder='Phone (optional)' onChange={this.handleChange} onKeyUp={this.handleChange} onFocus={this.handleFocus} value={this.state.phone} />
						</div>
						<div className='col-md-12 input-container text-center'>
							<input name='companyName' type='text' placeholder='Company' onChange={this.handleChange} onKeyUp={this.handleChange} onFocus={this.handleFocus} value={this.state.companyName} />
							<span className={this.state.companyName.length > 0 || !this.state.isCompanyNameFocused ? 'visibility-hidden message' : 'required-message message'}>This field is required</span>
						</div>
					</div>
					<div className='btn-container'>
                        {this.state.displayBtnLoader ?
                            <button className='contact-submit-btn' disabled={true}>
                                <span className='btn-loader'></span>
                            </button> :
                            <button className='contact-submit-btn' onClick={this.executeCaptcha} disabled={this.state.isSubmitDisabled}>
                                <span className='glyphicon glyphicon-send' aria-hidden="true"></span>Send
                            </button>}
                        <div className={this.state.isSubmitDisabled === 'disabled' ? 'overlay' : 'display-none overlay'} onClick={this.handleClick} id='submit_overlay'></div>
                    </div>
					<div className='badge-container'>
                        <Recaptcha
                            ref={e => recaptchaInstance = e}
                            sitekey="6LeTFnEUAAAAALfsaxcWZ9PF5d7tbv1zpayebpYB"
                            onResolved={this.verifyCallback}
                            badge="inline"
                        />
                    </div>
					<p className={'email-submit-response' + this.state.submitResponseColor}>{this.state.submitResponse}</p>
				</div>
				
			</div>
		);

	}
}